import Component from "@ember/component"
import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack, CardStackSummary } from "@shared/models/card-stack"
import type { Course, Unit } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type { Session } from "@shared/models/session"
import type AppState from "cc-frontend/services/app-state"
import type Dragging from "cc-frontend/services/dragging"
import type EmberStore from "cc-frontend/services/ember-store"
import { isArray, isNil, map, sortBy } from "lodash-es"
import styles from "./legacy-unit.module.css"

export default class LegacyUnit extends Component {
  readonly styles = styles
  // args
  models!: {
    cardStack: CardStack
    planbook: Planbook
    rotationCalendar: RotationCalendar
    course: Course
    lessonIsFulfilled: boolean
    unitInfo: Unit
    units: Array<CardStackSummary>
  }
  editCourseTitleAndOrder!: Function

  // state

  // services
  @service("ember-store") store!: EmberStore
  @service appState!: AppState
  @service session!: Session
  @service dragging!: Dragging

  @computed("models.cardStack.attributes.cards.[]")
  get cardAttributes() {
    if (this.models === undefined) return undefined
    if (isNil(this.models.cardStack) || isNil(this.models.cardStack.attributes)) return undefined
    let cards = this.models.cardStack.attributes.cards
    return map(cards, "attributes")
  }

  @computed("cardAttributes.@each.position")
  get sortedCards() {
    let cardAttributes = this.cardAttributes // have to trigger the computed property above
    if (
      isArray(cardAttributes) !== true ||
      isNil(this.models.cardStack) ||
      isNil(this.models.cardStack.attributes)
    )
      return undefined
    let cards = this.models.cardStack.attributes.cards
    return sortBy(cards, "attributes.position")
  }
}
